import type { ComponentProps } from "react";

import { cn } from "../foundations/cn.js";

/**
 * The page's content width: 1280 inside 80px gutters on desktop,
 * 32px on tablets, 16px on phones. Every
 * section of a template sits in one, so edges line up down the page.
 */
export function Section({ className, ...props }: ComponentProps<"section">) {
  return (
    <section
      className={cn("mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-20", className)}
      {...props}
    />
  );
}
